import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ObjectsState } from "domain/objects/entities/interfaces/object-state.interface";
import onObjectLocationReportedEventAction from "../actions/on-object-location-reported-event.action";
import { mapObjectToMarker } from "domain/objects/entities/mappers/map-object-to-marker.mapper";
import { shouldIncludeMarkerForInactivePreference } from "domain/objects/entities/mappers/map-objects-to-markers.mapper";

const onObjectLocationReportedEventCases = (
  builder: ActionReducerMapBuilder<ObjectsState>
) => {
  builder.addCase(
    onObjectLocationReportedEventAction.fulfilled,
    (state, action) => {
      const newObject = action.payload;

      if (newObject) {
        const objectIndex = state.objects.findIndex(
          (o) => o.uniqueId === newObject.uniqueId
        );
        if (objectIndex !== -1) {
          state.objects[objectIndex] = {
            ...state.objects[objectIndex],
            ...newObject
          };
        }

        if (state.selectedObject?.uniqueId === newObject.uniqueId) {
          state.selectedObject = newObject;
        }

        const status =
          newObject.status ??
          state.objectStatusesByUniqueId[newObject.uniqueId];

        if (
          !shouldIncludeMarkerForInactivePreference(
            status,
            state.showInactiveObjects
          )
        ) {
          state.markers = state.markers.filter(
            (m) => m.uniqueId !== newObject.uniqueId
          );
          return;
        }

        if (state.markers.length > 0) {
          const newMarker = mapObjectToMarker(newObject, status);

          const makerIndex = state.markers.findIndex(
            (m) => m.uniqueId === newObject.uniqueId
          );
          if (makerIndex !== -1 && newMarker) {
            state.markers[makerIndex] = {
              ...state.markers[makerIndex],
              ...newMarker
            };
          }
        }
      }
    }
  );
};

export default onObjectLocationReportedEventCases;
